import isShareDisabled from '../selectors/isShareDisabled';
import getPublishedStatus from '../selectors/getPublishedStatus';
import getFirstTimeUser from '../selectors/getFirstTimeUser';
import store from '../store/Store';
import getMailboxHash from '../selectors/getMailboxHash';
import type ServicesRequestStatus from '../store/schema/ServicesRequestStatus';
import getPbpSettingRequestStatus from '../selectors/getPbpSettingRequestStatus';
import showProgresBar from '../selectors/showProgressBar';
import isAutoPublishComplete from '../selectors/isAutoPublishComplete';
import { isFeatureEnabled } from 'owa-feature-flags';

/**
 * Util function gets whether or not we should show the publish button
 * 1. When it is not published
 *  a.  if the page is published on the attendee side aka isShareDisabled() != true
 *  b. the page is not published on organizer aka getPublishedStatus() != true
 *  c. we are done with the autopublish action for new users aka isAutoPublishComplete == true
 * 2. the booking page is not being intialized
 *  a. the user is not a first time user aka getFirstTimeUser() != true
 *  b. the page is not turning on aka store.isTurningOnBookingPage != true
 */
export default function showPublishButton(): boolean {
    // if the automatic publish failed for new users we should show the publish button
    const isTurningOnBookingPageForNewUser = store.isTurningOnBookingPage && getFirstTimeUser();
    const hasPublishedByOrganizer = getPublishedStatus() || isTurningOnBookingPageForNewUser;
    // helps keep track if we should show the bookings page as ready to the user or not.
    // If the mailbox hash is not retrieved, the booking page is not yet ready.
    const bookingDataLoaded =
        getMailboxHash() === null || getMailboxHash() === undefined ? false : true;

    const pageLoaded = bookingDataLoaded && getPbpSettingRequestStatus() == 2;

    //Existing user, page is unpublished
    const unpublishedExistingUser = !isShareDisabled() && !hasPublishedByOrganizer;

    //New user, page is unpublished
    // This happens if the autopulished failed AND we are are in the FRE experiance
    // Before we show the publish button we should first wait to make sure the autpublishing is complete
    const unpublishedNewUser =
        isAutoPublishComplete() && showProgresBar() && !hasPublishedByOrganizer;

    // If page is published on the attendee side, hide publish button
    const masterPublished = store.masterPublished;
    if (masterPublished) {
        return false;
    } else {
        return isFeatureEnabled('bookwithme-c1B2Migration')
            ? true
            : pageLoaded && (unpublishedExistingUser || unpublishedNewUser);
    }
}
